const RegMap = [
  {
    key: 'QQBrowser',
    reg: /(qqbrowser)\/([\d.]+)/
  },
  {
    key: 'QIHU360EE',
    reg: /qihu 360ee/
  },
  {
    key: 'QIHU360SE',
    reg: /qihu 360se/
  },
  {
    key: '2345Explorer',
    reg: /(2345explorer)\/([\d.]+)/
  },
  {
    key: 'Sogou',
    reg: /(metasr)/
  },
  {
    key: 'Wexin',
    reg: /(micromessenger)\/([\d.]+)/
  },
  {
    key: 'Openlanguage', // 开言
    reg: /(openlanguage)\/([\d.]+)/
  },
  {
    key: 'NewsArticle', // 头条
    reg: /(newsarticle)\/([\d.]+)/
  },
  {
    key: 'VideoArticle', // 西瓜
    reg: /(videoarticle)\/([\d.]+)/
  },
  {
    key: 'Hotsoon', // 火山
    reg: /(live_stream)_([\d.]+)/
  },
  {
    key: 'Aweme', // 抖音
    reg: /(aweme)_([\d.]+)/
  },
  {
    key: 'Lark', // 飞书
    reg: /(lark)\/([\d.]+)/
  },
  {
    key: 'PlayStation',
    reg: /(playstation)/
  },
  {
    key: 'BingPreview',
    reg: /(bingpreview)\/([\d.]+)/
  },
  {
    key: 'Baiduspider',
    reg: /(baiduspider-render)\/([\d.]+)/
  },
  {
    key: 'YandexBot',
    reg: /(yandexbot)\/([\d.]+)/
  },
  {
    key: 'Chrome',
    reg: /(chrome)\/([\d.]+)/
  },
  {
    key: 'Safari',
    reg: /(version)\/([\d.]+)\s*(safari)/
  }
]
const IERegMap = [{
  key: 'Trident',
  reg: /(rv:)([\d.]+)/
},
{
  key: 'Trident',
  reg: /(msie)\s*([\d.]+)/
}]

function isSupportMP4 () {
  const H264_MIMETYPES = [
    'avc1.42E01E, mp4a.40.2',
    'avc1.58A01E, mp4a.40.2',
    'avc1.4D401E, mp4a.40.2',
    'avc1.64001E, mp4a.40.2',
    'avc1.42E01E',
    'mp4v.20.8',
    'avc1.42E01E, mp4a.40.2',
    'avc1.58A01E, mp4a.40.2',
    'avc1.4D401E, mp4a.40.2',
    'avc1.64001E, mp4a.40.2',
    'mp4v.20.8, mp4a.40.2',
    'mp4v.20.240, mp4a.40.2'
  ]
  let a = document.createElement('video')
  const result = {
    isSupport: false,
    mime: ''
  }
  if (typeof a.canPlayType === 'function') {
    H264_MIMETYPES.map(key => {
      if (a.canPlayType(`video/mp4; codecs="${key}"`) === 'probably') {
        result.isSupport = true
        result.mime += `||${key}`
      }
    })
    return result
  }
  a = null
  return result
}

const SPIDER_UA = ['Baiduspider', 'YandexBot']
function checkIsSpider (name, ua) {
  let flag = false
  SPIDER_UA.map(key => {
    if (key === name) {
      flag = true
    }
  })
  /**
   * Google Mozilla/5.0 (compatible; Googlebot/2.1; +http://www.google.com/bot.html)
   * 俄罗斯 LinkpadBot Mozilla/5.0 (compatible; LinkpadBot/1.06; +http://www.linkpad.ru)
   * Sogou web spider/4.0(+http://www.sogou.com/docs/help/webmasters.htm#07)
   * 腾讯搜搜 Sogou web spider/4.0(+http://www.sogou.com/docs/help/webmasters.htm#07)
   * 360spider (http://webscan.360.cn)
   * 百度Mozilla/5.0 (compatible; Baiduspider-render/2.0; +http://www.baidu.com/search/spider.html)
   * 爬虫UA汇总 https://yq.aliyun.com/articles/655062
   */
  // 通用爬虫UA校验
  if (/(\+http|; http|\(http):\/\/([\w.]+\/?)\S*/.test(ua)) {
    flag = true
  }
  return flag
}

function detect (ua = '') {
  ua = ua.toLocaleLowerCase()
  const isIOS = (/(iphone)/.test(ua) || /(ipad)/.test(ua))
  const isAndroid = /(android)/.test(ua)
  const isWP = /(windows phone)/.test(ua)
  const isMobile = (isIOS || isAndroid || isWP)
  const browser = {
    isIOS: isIOS,
    isAndroid: isAndroid,
    isMobile: isMobile,
    isPC: !isMobile,
    isPad: /(ipad)/.test(ua)
  }

  const result = isSupportMP4()
  browser.isSupportMP4 = result.isSupport
  browser.mime = result.mime

  let appNameKey = ''
  let appVersion = 0
  let match = []
  let _regMap = RegMap
  if (/trident/.test(ua)) {
    _regMap = IERegMap
  }

  for (let i = 0; i < _regMap.length; i++) {
    match = _regMap[i].reg.exec(ua)
    if (match) {
      appNameKey = _regMap[i].key
      appVersion = match.length > 2 ? match[2] : ''
      break
    }
  }

  if (appNameKey) {
    browser[`is${appNameKey}`] = true
    browser.name = appNameKey
    browser.appVersion = appVersion
  } else {
    const is360 = checkIs360()
    is360 && (browser.name = '360EE')
  }
  // 非IE检测是否为兼容模式
  if (browser.name && browser.name !== 'Trident') {
    // 浏览器兼容模式判断
    const isTrident = /(trident)/.exec(ua)
    if (isTrident) {
      browser.name = browser.name ? `${browser.name}_Trident` : 'Trident'
    }
  }

  browser.isSpider = checkIsSpider(browser.name)
  return browser
}

function checkIs360 () {
  const mimeTypes = navigator.mimeTypes
  if (mimeTypes) {
    for (let i = 0; i < mimeTypes.length; i++) {
      if (mimeTypes[i].type && mimeTypes[i].type.indexOf('360') > -1) {
        return true
      }

      if (mimeTypes[i].type && mimeTypes[i].type.indexOf('application/vnd.chromium.remoting-viewer') > -1) {
        return true
      }

      if (mimeTypes[i].description && mimeTypes[i].description.indexOf('360') > -1) {
        return true
      }
    }

    return false
  }
}
/**
 * Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/69.0.3497.100 Safari/537.36 QIHU 360EE
 * Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/69.0.3497.100 Safari/537.36 QIHU 360SE
 * Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/56.0.2924.90 Safari/537.36 2345Explorer/9.6.0.18627
 * Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.25 Safari/537.36 Core/1.70.3722.400 QQBrowser/10.5.3738.400
 * 搜狗 "Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 SE 2.X MetaSr 1.0"
 * 爬虫 Mozilla/5.0 (compatible; YandexBot/3.0; +http://yandex.com/bots) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/51.0.2704.106
 * 百度爬虫 Mozilla/5.0 (compatible; Baiduspider-render/2.0; +http://www.baidu.com/search/spider.html)
 */
const Browser = typeof navigator !== 'undefined' && detect(navigator.userAgent)
export default Browser
